/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { getClientImagePath } from '@exo/frontend-common-utils';
import { Product } from '../model/types';

function modifyCategoryName(name) {
  const categories = ['gold', 'silver', 'platinum'];
  if (categories.includes(name)) {
      return name + 's';
  }
  return name;
}

export const processProductList = (nodes: ProductEdge[], prices, sort?) => {
  if (sort === 'PRICE_ASCENDING') {
    return nodes
      ?.map(({ node }) => {
        const priceInfo = prices?.find(price => price.partNumber === node.partnumber)?.unitPrice[0]
          ?.price?.value;
        return {
          img: {
            src: getClientImagePath(node?.thumbnail ?? process.env.PRODUCT_PLACEHOLDER),
            alt: node?.name
          },
          id: node?.slug ?? node?.partnumber,
          partnumber: node?.partnumber,
          productId: node.id,
          type: node.type,
          name: node?.name,
          price: priceInfo,
          buyable: node?.buyable,
          topParentCatName: modifyCategoryName(node?.topParentCatName),
          ...(node.reviews
            ? {
                rating: Math.floor(node?.reviews?.averageRating),
                reviewTotal: node?.reviews?.reviewCount,
                hasRating: true
              }
            : {}),
            availability: {
              online: node?.availability?.find(a => a.distributionGroup)?.status,
              store: node?.availability?.find(a => a.shipNode)?.status,
              storeName: node?.availability?.find(a => a.shipNode)?.shipNode?.name
            },
          productTag: node?.attributes?.find(attr => attr?.id.split('_')[0] === 'tdProductTag')
            ?.value?.value
        };
      })
      ?.sort((a, b) => a.price - b.price);
  } else if (sort === 'PRICE_DESCENDING') {
    return nodes
      ?.map(({ node }) => {
        const priceInfo =
          prices &&
          prices?.length > 0 &&
          prices?.find(price => price.partNumber === node.partnumber)?.unitPrice[0]?.price?.value;
        return {
          img: {
            src: getClientImagePath(node?.thumbnail ?? process.env.PRODUCT_PLACEHOLDER),
            alt: node?.name
          },
          id: node?.slug ?? node?.partnumber,
          partnumber: node?.partnumber,
          productId: node.id,
          type: node.type,
          buyable: node?.buyable,
          name: node?.name,
          price: priceInfo,
          topParentCatName: modifyCategoryName(node?.topParentCatName),
          ...(node.reviews
            ? {
                rating: Math.floor(node?.reviews?.averageRating),
                reviewTotal: node?.reviews?.reviewCount,
                hasRating: true
              }
            : {}),
          availability: {
            online: node?.availability?.find(a => a.distributionGroup)?.status,
            store: node?.availability?.find(a => a.shipNode)?.status,
            storeName: node?.availability?.find(a => a.shipNode)?.shipNode?.name
          },
          productTag: node?.attributes?.find(attr => attr?.id.split('_')[0] === 'tdProductTag')
            ?.value?.value
        };
      })
      ?.sort((a, b) => b.price - a.price);
  } else {
    return nodes?.map(({ node }) => {
      const priceInfo = prices.find(price => price.partNumber === node.partnumber)?.unitPrice[0]
        ?.price?.value;
      return {
        img: {
          src: getClientImagePath(node?.thumbnail ?? process.env.PRODUCT_PLACEHOLDER),
          alt: node?.name
        },
        id: node?.slug ?? node?.partnumber,
        partnumber: node?.partnumber,
        productId: node.id,
        type: node.type,
        buyable: node?.buyable,
        name: node?.name,
        price: priceInfo && priceInfo?.unitPrice?.length ? priceInfo : '',
        topParentCatName: modifyCategoryName(node?.topParentCatName),
        ...(node.reviews
          ? {
              rating: Math.floor(node?.reviews?.averageRating),
              reviewTotal: node?.reviews?.reviewCount,
              hasRating: true
            }
          : {}),
        availability: {
          online: node?.availability?.find(a => a.distributionGroup)?.status,
          store: node?.availability?.find(a => a.shipNode)?.status,
          storeName: node?.availability?.find(a => a.shipNode)?.shipNode?.name
        },
        productTag: node?.attributes?.find(attr => attr?.id.split('_')[0] === 'tdProductTag')?.value
          ?.value
      };
    });
  }
};

type ProductEdge = {
  node: Product;
};
